<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :title="title"
            :load_url="load_url"
            :options="options"
            :options_label="options_text">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'ProcessingErrorsByAgent',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            return {
                chart_type: 'bar',
                color: '#76d561',
                title: 'Processing Errors by agent',
                load_url: '/dashboards/ProcessingErrorsByAgents',
                time_wait: 10000,
                options: ['today', 'yesterday','last7days','this_month','last_month'],
                options_text: ['Today', 'Yesterday','Last 7 Days','This Month','Last Month'],
                chart_layout: [
                    {
                        'label': 'Total Processing Errors',
                        'backgroundColor': 'rgb(33,41,213)', //can be an array for other graph types
                        'borderColor': 'rgba(220, 220, 220, 1)',
                        'pointBackgroundColor': 'rgba(220, 220, 220, 1)',
                        'pointBorderColor': '#fff',
                        'pointHighlightFill': '#fff',
                        'pointHighlightStroke': 'rgba(220, 220, 220, 1)',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>